// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.paddingTopBottom {
    padding: 50px 0;
    position: relative;
}

.swiperSliderRelativeContainer {
    position: relative;
}

.whatWeOfferSwiperNavigationNextBtn,
.whatWeOfferSwiperNavigationPrevBtn {
    position: absolute;
    top: 48px;
    width: 38px;
    height: 38px;
    cursor: pointer;
    z-index: 1;
    padding: 10px;
    display: flex;
    align-items: center;
    justify-content: center;
    background: var(--background-primary);
    color: var(--primary-foreground);
    border: 1px solid var(--primary-border);
    border-radius: 50%;
    z-index: 1;
    outline: unset !important;
    box-shadow: 0px 2px 7px 0px var(--shadow-5);
}

.whatWeOfferSwiperNavigationNextBtn {
    right: 0;
}

.whatWeOfferSwiperNavigationPrevBtn {
    left: 0;
}

.whatWeOfferSwiperNavigationNextBtn:disabled,
.whatWeOfferSwiperNavigationPrevBtn:disabled {
    display: none;
}

/* sub Categories swiper start */

.subCategorySwiperNavigationPrevBtn,
.subCategorySwiperNavigationNextBtn {
    position: absolute;
    top: 50%;
    width: 34px;
    height: 34px;
    display: flex;
    align-items: center;
    justify-content: center;
    background: var(--common-white-bg);
    border: 1px solid var(--primary-border);
    border-radius: 50%;
    transform: translateY(-50%);
    cursor: pointer;
    z-index: 1;
}

.subCategorySwiperNavigationPrevBtn.swiper-button-disabled,
.subCategorySwiperNavigationNextBtn.swiper-button-disabled {
    display: none;
}

.subCategorySwiperNavigationNextBtn {
    right: -10px;
}

.subCategorySwiperNavigationPrevBtn {
    left: -10px;
}

/* top Category swiper start */

.topCategorySwiperNavigationBtn {
    position: absolute;
    top: calc((160px / 2) - 5px);
    display: flex;
    align-items: center;
    justify-content: center;
    width: 38px;
    height: 38px;
    border-radius: 50%;
    z-index: 1;
}

.topCategorySwiperNavigationBtn,
.topCategorySwiperNavigationBtn:hover,
.topCategorySwiperNavigationBtn:focus,
.topCategorySwiperNavigationBtn:active:hover,
.topCategorySwiperNavigationBtn:active:focus {
    background: var(--background-tertiary);
    border: 1px solid var(--primary-border);
    box-shadow: 0px 2px 7px 0px var(--shadow-5);
    color: var(--primary-foreground);
    outline: none;
    padding: 0;
}

.topCategorySwiperNavigationNextBtn {
    right: 0;
}

.topCategorySwiperNavigationPrevBtn {
    left: 0;
}

.topCategorySwiperNavigationBtn.swiper-button-disabled {
    display: none;
}

/* top Category swiper end */
/* swiper rtl style only */

.rtl .whatWeOfferSwiperNavigationNextBtn {
    right: unset;
    left: 0;
    transform: scale(-1);
}

.rtl .whatWeOfferSwiperNavigationPrevBtn {
    left: unset;
    right: 0;
    transform: scale(-1);
}

.rtl .topCategorySwiperNavigationNextBtn {
    right: unset;
    left: 0;
}

.rtl .topCategorySwiperNavigationPrevBtn {
    left: unset;
    right: 0;
}

.rtl .topCategorySwiperNavigationNextBtn,
.rtl .topCategorySwiperNavigationPrevBtn {
    transform: rotate(180deg);
}`, "",{"version":3,"sources":["webpack://./src/styles/customSwiper.css"],"names":[],"mappings":"AAAA;IACI,eAAe;IACf,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;;IAEI,kBAAkB;IAClB,SAAS;IACT,WAAW;IACX,YAAY;IACZ,eAAe;IACf,UAAU;IACV,aAAa;IACb,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,qCAAqC;IACrC,gCAAgC;IAChC,uCAAuC;IACvC,kBAAkB;IAClB,UAAU;IACV,yBAAyB;IACzB,2CAA2C;AAC/C;;AAEA;IACI,QAAQ;AACZ;;AAEA;IACI,OAAO;AACX;;AAEA;;IAEI,aAAa;AACjB;;AAEA,gCAAgC;;AAEhC;;IAEI,kBAAkB;IAClB,QAAQ;IACR,WAAW;IACX,YAAY;IACZ,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,kCAAkC;IAClC,uCAAuC;IACvC,kBAAkB;IAClB,2BAA2B;IAC3B,eAAe;IACf,UAAU;AACd;;AAEA;;IAEI,aAAa;AACjB;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,WAAW;AACf;;AAEA,8BAA8B;;AAE9B;IACI,kBAAkB;IAClB,4BAA4B;IAC5B,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,UAAU;AACd;;AAEA;;;;;IAKI,sCAAsC;IACtC,uCAAuC;IACvC,2CAA2C;IAC3C,gCAAgC;IAChC,aAAa;IACb,UAAU;AACd;;AAEA;IACI,QAAQ;AACZ;;AAEA;IACI,OAAO;AACX;;AAEA;IACI,aAAa;AACjB;;AAEA,4BAA4B;AAC5B,0BAA0B;;AAE1B;IACI,YAAY;IACZ,OAAO;IACP,oBAAoB;AACxB;;AAEA;IACI,WAAW;IACX,QAAQ;IACR,oBAAoB;AACxB;;AAEA;IACI,YAAY;IACZ,OAAO;AACX;;AAEA;IACI,WAAW;IACX,QAAQ;AACZ;;AAEA;;IAEI,yBAAyB;AAC7B","sourcesContent":[".paddingTopBottom {\n    padding: 50px 0;\n    position: relative;\n}\n\n.swiperSliderRelativeContainer {\n    position: relative;\n}\n\n.whatWeOfferSwiperNavigationNextBtn,\n.whatWeOfferSwiperNavigationPrevBtn {\n    position: absolute;\n    top: 48px;\n    width: 38px;\n    height: 38px;\n    cursor: pointer;\n    z-index: 1;\n    padding: 10px;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    background: var(--background-primary);\n    color: var(--primary-foreground);\n    border: 1px solid var(--primary-border);\n    border-radius: 50%;\n    z-index: 1;\n    outline: unset !important;\n    box-shadow: 0px 2px 7px 0px var(--shadow-5);\n}\n\n.whatWeOfferSwiperNavigationNextBtn {\n    right: 0;\n}\n\n.whatWeOfferSwiperNavigationPrevBtn {\n    left: 0;\n}\n\n.whatWeOfferSwiperNavigationNextBtn:disabled,\n.whatWeOfferSwiperNavigationPrevBtn:disabled {\n    display: none;\n}\n\n/* sub Categories swiper start */\n\n.subCategorySwiperNavigationPrevBtn,\n.subCategorySwiperNavigationNextBtn {\n    position: absolute;\n    top: 50%;\n    width: 34px;\n    height: 34px;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    background: var(--common-white-bg);\n    border: 1px solid var(--primary-border);\n    border-radius: 50%;\n    transform: translateY(-50%);\n    cursor: pointer;\n    z-index: 1;\n}\n\n.subCategorySwiperNavigationPrevBtn.swiper-button-disabled,\n.subCategorySwiperNavigationNextBtn.swiper-button-disabled {\n    display: none;\n}\n\n.subCategorySwiperNavigationNextBtn {\n    right: -10px;\n}\n\n.subCategorySwiperNavigationPrevBtn {\n    left: -10px;\n}\n\n/* top Category swiper start */\n\n.topCategorySwiperNavigationBtn {\n    position: absolute;\n    top: calc((160px / 2) - 5px);\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    width: 38px;\n    height: 38px;\n    border-radius: 50%;\n    z-index: 1;\n}\n\n.topCategorySwiperNavigationBtn,\n.topCategorySwiperNavigationBtn:hover,\n.topCategorySwiperNavigationBtn:focus,\n.topCategorySwiperNavigationBtn:active:hover,\n.topCategorySwiperNavigationBtn:active:focus {\n    background: var(--background-tertiary);\n    border: 1px solid var(--primary-border);\n    box-shadow: 0px 2px 7px 0px var(--shadow-5);\n    color: var(--primary-foreground);\n    outline: none;\n    padding: 0;\n}\n\n.topCategorySwiperNavigationNextBtn {\n    right: 0;\n}\n\n.topCategorySwiperNavigationPrevBtn {\n    left: 0;\n}\n\n.topCategorySwiperNavigationBtn.swiper-button-disabled {\n    display: none;\n}\n\n/* top Category swiper end */\n/* swiper rtl style only */\n\n.rtl .whatWeOfferSwiperNavigationNextBtn {\n    right: unset;\n    left: 0;\n    transform: scale(-1);\n}\n\n.rtl .whatWeOfferSwiperNavigationPrevBtn {\n    left: unset;\n    right: 0;\n    transform: scale(-1);\n}\n\n.rtl .topCategorySwiperNavigationNextBtn {\n    right: unset;\n    left: 0;\n}\n\n.rtl .topCategorySwiperNavigationPrevBtn {\n    left: unset;\n    right: 0;\n}\n\n.rtl .topCategorySwiperNavigationNextBtn,\n.rtl .topCategorySwiperNavigationPrevBtn {\n    transform: rotate(180deg);\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
